import React from 'react';
import { Logo } from '../../components/auth/login/Logo';
import { PasswordResetForm } from '../../components/auth/password-reset/PasswordResetForm';
import { Footer } from '../../components/common/Footer';

export function PasswordResetPage() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <div className="flex-grow flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <Logo />
          <PasswordResetForm />
        </div>
      </div>
      <Footer />
    </div>
  );
}